module.exports = __webpack_public_path__ + "media/images/index-hero-badge-jp-698b84741a8c615ced3a1f6428a5c69f.svg";